export const provider = () => {
    return {
        slq_list_identification_type_id: null,
        identification: null,
        name: null,
        address: null,
        telephone: null
    };
};

export const params = () => {
    return {
        filter: null,
        page: 1,
        per_page: 10,
        paginate: 1,
        company_id: null
    };
};

export default {
    providers: {
        data: []
    },
    provider: provider(),
    params: params(),
    identification_types: []
};
